import {Component, OnInit} from '@angular/core';
import {TableColumn} from "../../../../dto/util/table-column";
import {TranslateService} from "@ngx-translate/core";
import {TableAction} from "../../../../dto/util/table-action";
import {InfoPantallaDTO} from "../../../../dto/util/infoPantallaDTO";
import {UtilService} from "../../../../services/util.service";
import {ExpedienteService} from "../../../../services/expediente.service";
import {ActivatedRoute} from "@angular/router";
import {EstadoFinancieroSSIDTO, ExpedienteSSIDTO, HistoricoSSIDTO} from "../models/expedienteSSIDTO";

@Component({
  selector: 'app-detalle-supersociedades-insolvencia',
  templateUrl: './detalle-supersociedades-insolvencia.component.html',
  styleUrl: './detalle-supersociedades-insolvencia.component.scss'
})
export class DetalleSupersociedadesInsolvenciaComponent implements OnInit{
  // Tabla
  columnas: TableColumn[] = [];
  acciones: TableAction[] = [];
  //Histórico
  columnasHistorico: TableColumn[] = [];
  // Histórico segunda parte
  columnasHistoricoSegundaParte: TableColumn[] = [];
  accionesHistoricoSegundaParte: TableAction[] = [];
  // Tabla boton ver
  columnasTablaVer: TableColumn[] = [];
  // Multilenguaje
  insolvenciaText: any = {};
  guiaText: any = {};
  guiaInsolvenciaText: any = {};
  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;
  // Number
  idExpediente!: number;
  idExpedienteSSI!: number;
  // Datos de las tablas
  datosExpedienteSSI: ExpedienteSSIDTO[] = [];
  datosHistoricoSSI: HistoricoSSIDTO[] = [];
  datosHistoricoSegundaParteSSI: HistoricoSSIDTO[] = [];
  datosEstadoFinancieroSSI: EstadoFinancieroSSIDTO[] = [];
  // Boolean
  mostrarHistorico = false;
  mostrarDetalle = false;
   constructor(
    private readonly translate: TranslateService,
    private readonly utilService: UtilService,
    private readonly expedienteService: ExpedienteService,
    private readonly route: ActivatedRoute,
  ) {
    // Multilenguaje
    this.translate.stream('guias-interactivas').subscribe(text => {
      this.guiaText = text;
      this.ngOnInit();
    });
    this.translate.stream('guia-supersociedades-insolvencia').subscribe(text => {
      this.guiaInsolvenciaText = text;
      this.ngOnInit();
    });
    // Se captura de la url, el ID del expediente
    this.route.params.subscribe(params => {
      this.idExpediente = params['expedienteId'];
    });
  }
  ngOnInit(): void {
    // Se inicializan las columnas de la tabla
    this.initColumns();
    // Multilenguaje
    this.translate.stream('supersociedades-insolvencia').subscribe(text => {
      this.insolvenciaText = text;
      this.initColumns();
      this.initColumnsHistorico();
      this.initColumnsHistoricoSegundaParte();
      this.initColumnsBotonVer();
    });
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaInsolvenciaText['titulo'],
      descripcionPantalla: '',
      pasos: [
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#id',
          popover: {
            title: 'ID',
            description: this.guiaInsolvenciaText['ID'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#deudor',
          popover: {
            title: this.insolvenciaText['deudor-solicitante'],
            description: this.guiaInsolvenciaText['deudor'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#numeroProceso',
          popover: {
            title: this.insolvenciaText['proceso'],
            description: this.guiaInsolvenciaText['proceso'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#radicado',
          popover: {
            title: this.insolvenciaText['numero-radicado'],
            description: this.guiaInsolvenciaText['radicado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaCarga',
          popover: {
            title: this.insolvenciaText['fecha-carga'],
            description: this.guiaInsolvenciaText['fecha-carga'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#fechaRadicacion',
          popover: {
            title: this.insolvenciaText['fecha-radicacion'],
            description: this.guiaInsolvenciaText['fecha-radicacion'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#estado',
          popover: {
            title: this.insolvenciaText['estado'],
            description: this.guiaInsolvenciaText['estado'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#usuarioSolicitante',
          popover: {
            title: this.insolvenciaText['usuario'],
            description: this.guiaInsolvenciaText['usuario'],
            side: 'bottom',
            align: 'start',
          }
        },
        {
          element: '#proceso',
          popover: {
            title: this.insolvenciaText['proceso'],
            description: this.guiaInsolvenciaText['proceso'],
            side: 'bottom',
            align: 'start',
          }
        }
      ]
    }
    // Se obtiene los datos de sesión del usuario
    const dataUsuario = JSON.parse(
      sessionStorage.getItem('user_information_session')!
    );
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (dataUsuario.primerInicioSesion) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
    // Se lista expediente SSI
    this.listarExpediente();
  }

  // Columnas de la tabla
  initColumns() {
    this.columnas = [
      {
        id: 'id',
        field: 'id',
        title: 'ID',
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'deudor',
        field: 'deudorSolicitante',
        title: this.insolvenciaText['deudor-solicitante'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'numeroProceso',
        field: 'numeroProceso',
        title: this.insolvenciaText['numero-proceso'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'radicado',
        field: 'numeroRadicado',
        title: this.insolvenciaText['numero-radicado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'fechaCarga',
        field: 'fechaCargaInformacion',
        title: this.insolvenciaText['fecha-carga'],
        type: 'date',
        filterable: false,
        sortable: false,
        pipe: 'dd/MM/yyyy'
      },
      {
        id: 'fechaRadicacion',
        field: 'fechaRadicacion',
        title: this.insolvenciaText['fecha-radicacion'],
        type: 'date',
        filterable: false,
        sortable: false,
        pipe: 'dd/MM/yyyy'
      },
      {
        id: 'estado',
        field: 'estado',
        title: this.insolvenciaText['estado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'usuarioSolicitante',
        field: 'usuarioSolicitante',
        title: this.insolvenciaText['usuario-solicitante'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'proceso',
        field: 'proceso',
        title: this.insolvenciaText['proceso'],
        type: 'text',
        filterable: false,
        sortable: false,
      }
    ]
    // Columna de acciones
    this.acciones = [
      {
        type: 'button',
        icon: 'history',
        title: this.insolvenciaText['historial'],
        idAccion: '1',
      },
      {
        type: 'button',
        icon: 'eye',
        title: this.insolvenciaText['detalle'],
        idAccion: '2',
      },
    ];
  }

  // Columnas de la tabla histórico
  initColumnsHistorico() {
    this.columnasHistorico = [
      {
        id: 'tipo',
        field: 'solicitud.tipo',
        title: this.insolvenciaText['tipo'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'identificador',
        field: 'solicitud.identificadorSolicitud',
        title: this.insolvenciaText['identificador'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'deudor',
        field: 'solicitud.deudorSolicitante',
        title: this.insolvenciaText['deudor-solicitante'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'fechaRadicacion',
        field: 'solicitud.fechaRadicacion',
        title: this.insolvenciaText['fecha-radicacion'],
        type: 'date',
        filterable: false,
        sortable: false,
        pipe: 'dd/MM/yyyy'
      },
      {
        id: 'estado',
        field: 'solicitud.estado',
        title: this.insolvenciaText['estado'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ]
  }

  // Columnas de la tabla histórico, segunda tabla
  initColumnsHistoricoSegundaParte() {
    this.columnasHistoricoSegundaParte = [
      {
        id: 'tipoSolicitante',
        field: 'detalle.tipoSolicitante',
        title: this.insolvenciaText['tipo-solicitante'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'tipoSolicitud',
        field: 'detalle.tipoSolicitud',
        title: this.insolvenciaText['tipo-solicitud'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'identificacionDeudor',
        field: 'detalle.identificacionDeudor',
        title: this.insolvenciaText['id-deudor'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'memoriaExplicativa',
        field: 'detalle.memoriaExplicativa',
        title: this.insolvenciaText['memoria-explicativa'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'situacion',
        field: 'detalle.situacionPresentada',
        title: this.insolvenciaText['situacion'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'seAdelantaCon',
        field: 'detalle.certificadoNegociacion',
        title: this.insolvenciaText['se-adelanta-con'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '250px'
      },
      {
        id: 'pasivos',
        field: 'detalle.relacionPasivos',
        title: this.insolvenciaText['pasivos'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'infoFinanciera',
        field: 'detalle.informacionFinanciera',
        title: this.insolvenciaText['info-financiera'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '250px'
      },
      {
        id: 'checklistSolicitud',
        field: 'detalle.checklistSolicitud',
        title: this.insolvenciaText['checklist'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'radicadoPostal',
        field: 'detalle.numeroRadicadoPostal',
        title: this.insolvenciaText['radicado-postal'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'intendencia',
        field: 'detalle.intendenciaRegional',
        title: this.insolvenciaText['intendencia'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
      {
        id: 'numeroProceso',
        field: 'detalle.numeroProceso',
        title: this.insolvenciaText['numero-proceso'],
        type: 'text',
        filterable: false,
        sortable: false,
      },
    ]
    // Columna de acciones histórico segunda parte
    this.accionesHistoricoSegundaParte = [
      {
        type: 'button',
        icon: 'eye',
        title: this.insolvenciaText['detalle'],
        idAccion: '1',
      },
    ];
  }

  // Columnas de la tabla que muestra el detalle de transacción a través del botón ver
  initColumnsBotonVer(){
    this.columnasTablaVer = [
      {
        id: 'activos',
        field: 'valorTotalActivosMesAnterior',
        title: this.insolvenciaText['activos'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'totalPasivos',
        field: 'valorTotalPasivosMesAnterior',
        title: this.insolvenciaText['total-pasivos'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'patrimonio',
        field: 'valorTotalPatrimonioMesAnterior',
        title: this.insolvenciaText['patrimonio'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'ingresosOrdinarios',
        field: 'valorTotalIngresosOrdinariosAnoAnterior',
        title: this.insolvenciaText['ingresos-ordinarios'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'ingresos',
        field: 'valorTotalOtrosIngresosAnoAnterior',
        title: this.insolvenciaText['ingresos'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'inversiones',
        field: 'tieneInversiones',
        title: this.insolvenciaText['inversiones'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '200px'
      },
      {
        id: 'participacion',
        field: 'valorTotalParticipacionMetodoParticipacion',
        title: this.insolvenciaText['participacion'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '200px'
      },
      {
        id: 'participacionCosto',
        field: 'valorTotalParticipacionMetodoCosto',
        title: this.insolvenciaText['participacion-costo'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '200px'
      },
      {
        id: 'participacionRazonable',
        field: 'valorTotalParticipacionMetodoValorRazonable',
        title: this.insolvenciaText['participacion-razonable'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '200px'
      },
      {
        id: 'estadosFinancieros',
        field: 'fechaEstadosFinancierosMesAnterior',
        title: this.insolvenciaText['estados-financieros'],
        type: 'date',
        filterable: false,
        sortable: false,
        width: '150px',
        pipe: 'dd/MM/yyyy'
      },
      {
        id: 'totalActivos',
        field: 'valorTotalActivosAnoAnterior',
        title: this.insolvenciaText['total-activos'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'totalPasivosAnual',
        field: 'valorTotalPasivosAnoAnterior',
        title: this.insolvenciaText['total-pasivos-anual'],
        type: 'text',
        filterable: false,
        sortable: false,
        width: '100px'
      },
      {
        id: 'estadosFinancierosAnual',
        field: 'fechaEstadosFinancierosAnoAnterior',
        title: this.insolvenciaText['estados-financieros-anual'],
        type: 'date',
        filterable: false,
        sortable: false,
        width: '100px',
        pipe: 'dd/MM/yyyy'
      },
      {
        id: 'acreedores',
        field: 'fechaRelacionBienAcreedor',
        title: this.insolvenciaText['acreedores'],
        type: 'date',
        filterable: false,
        sortable: false,
        width: '100px',
        pipe: 'dd/MM/yyyy'
      }
    ]
  }

  // Se consume el servicio de listar expediente SSI
  listarExpediente() {
    this.expedienteService.expedienteSSI(this.idExpediente).subscribe((resp: ExpedienteSSIDTO[]) => {
      this.datosExpedienteSSI = resp;
    });
  }

  // Se validan las acciones de la tabla principal de detalle expediente
  accionesExpedienteSSI(elemento: any) {
     // Si la acción es historial, se muestran las tablas correspondientes
     if (elemento.idAccion === '1') {
       this.mostrarHistorico = true;
       this.initColumnsHistorico();
       this.initColumnsHistoricoSegundaParte();
       // Servicio que lista el histórico del expediente seleccionado
       this.listarHistorico();
     } else {
       this.mostrarHistorico = false;
     }

    // Si la acción es ver detalle, se muestra la tabla correspondiente
    if (elemento.idAccion === '2') {
      this.mostrarDetalle = true;
      this.initColumnsBotonVer();
      this.listarEstadoFinanciero();
    } else {
      this.mostrarDetalle = false;
    }
    // Se guarda el id del registro seleccionado
    this.idExpedienteSSI = elemento.item.id;
  }

  // Se consume el servicio de listar expediente SSI
  listarHistorico(){
    this.expedienteService.detalleSSI(this.idExpedienteSSI).subscribe((resp: HistoricoSSIDTO[]) => {
      this.datosHistoricoSSI = resp;
      this.datosHistoricoSegundaParteSSI = resp;
    });
  }

  // Se validan las acciones de la tabla principal de histórico
  accionesHistoricoSSI(elemento: any) {
    // Si la acción es ver detalle, se muestra la tabla correspondiente
    if (elemento.idAccion === '1') {
      this.mostrarDetalle = true;
      this.initColumnsBotonVer();
      this.listarEstadoFinanciero();
    } else {
      this.mostrarDetalle = false;
    }
  }


  // Se consume el servicio de listar estado financiero SSI
  listarEstadoFinanciero(){
    this.expedienteService.estadoFinancieroSSI(this.idExpedienteSSI).subscribe((resp: EstadoFinancieroSSIDTO[]) => {
      this.datosEstadoFinancieroSSI = resp;
    });
  }
}
